export function isSsoValidationRoute(pathname, search = "") {
  if (pathname !== "/") return false;
  return Boolean(new URLSearchParams(search).get("ssoToken"));
}
